import * as types from "./actionTypes.js";


export function updateHamburgerMenuStatus(status) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_HAMBURGER_MENU_STATUS,
      status
    });
  };
}

export function updateTheme(theme) {
  return function(dispatch) {
    dispatch({
      type: types.UPDATE_THEME,
      theme
    });
  };
}
